import { IRequestPayload } from 'core/types';

export enum DirectShipType {
  AMOUNT = 'Amount',
  PERCENTAGE = 'Percentage',
}

export interface IVendorSearchRequestPayload extends IRequestPayload {
  filters: {
    query?: string;
  };
}

export interface IVendor {
  contactGroupId?: number;
  id: number;
  vendorId: string;
  vendorName: string;
}

export interface ISupplier {
  isShipAndDebit?: boolean;
  primaryContact?: ISupplierPrimaryContact | null;
  purchasingAttributes?: (ISupplierPurchasingAttribute | null)[];
}

/**
 * The supplier site's primary contact, straight out of the ERP payload — `contactName`, `email`,
 * `phonenumber` and the `contactId` this type deliberately does not declare are all ERP values.
 *
 * `partfinitiContactId` / `corporateUserId` / `companyName` are the Partfiniti contact that
 * supplier email resolves to. They ride every `/contacts/contact-group-address/list` row whose
 * `primaryContact` is an object, but only when the request carries
 * `filters[contactGroupType] = vendor`. `partfinitiContactId` and `corporateUserId` are null
 * together — null means the email resolves to nobody this company can put on a quote, so there is
 * nothing to prefill. `companyName` is nullable on its own and is a label only.
 */
export interface ISupplierPrimaryContact {
  companyName?: string | null;
  contactName: string;
  corporateUserId?: number | null;
  email?: string;
  partfinitiContactId?: number | null;
  phonenumber?: string;
  shippingLocation: string;
}

export interface ISupplierPurchasingAttribute {
  directShip?: DirectShipType;
  directShipFee?: string;
  dsBuyer?: string;
  dsFreightTerms?: string;
  fob?: string;
  freightTerms?: string;
  minOrderAmount?: number;
  minOrderFee?: number;
  minOrderQuantity?: number;
  minOrderWeight?: number;
  minTransactionAmount?: number;
  minTransactionWeight?: number;
  nonStockBuyer?: string;
  notes?: string;
  shipMethod?: string;
  shippingLocation?: string;
  stockBuyer?: string;
}
